import { render, staticRenderFns } from "./selectTheResource.vue?vue&type=template&id=7e769086&"
import script from "./selectTheResource.vue?vue&type=script&lang=js&"
export * from "./selectTheResource.vue?vue&type=script&lang=js&"
import style0 from "./selectTheResource.vue?vue&type=style&index=0&id=7e769086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports